import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TRANSLATION } from '@/modules/translation/router';
import { translationService } from '@/services/translation';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useTranslationAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: ''
    });

    const validations = {
        name: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => translationService.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_TRANSLATION.INDEX })
    });

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () => translationService.create(model.name),
            onSuccess: () => router.go(-1)
        }),

        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => translationService.update(model.id, model.name),
            onSuccess: () => router.go(-1)
        }),
        submit: async () => {
            if (model.id) {
                actions.update();
            } else {
                actions.create();
            }
        }
    };

    onMounted(() => fetch());

    return { model, v$, fetch, actions };
}
